import { render, staticRenderFns } from "./CancelAppointment.vue?vue&type=template&id=0044e6e1"
import script from "./CancelAppointment.vue?vue&type=script&lang=js"
export * from "./CancelAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports